// extracted by mini-css-extract-plugin
module.exports = {"container":"paymentForm_container__2hOBb","paid":"paymentForm_paid__1_KrO"};